import { useEffect, useState } from "react";

const IDLE_MS = 120000;
const COUNTDOWN_S = 15;
const EVENTS = ["pointerdown", "touchstart", "keydown", "scroll"];

export const KioskIdleGuard = ({ active, onTimeout }) => {
    const [left, setLeft] = useState(null);

    useEffect(() => {
        if (!active) { setLeft(null); return; }
        let t;
        const arm = () => { clearTimeout(t); setLeft(null); t = setTimeout(() => setLeft(COUNTDOWN_S), IDLE_MS); };
        arm();
        EVENTS.forEach((e) => window.addEventListener(e, arm, { passive: true, capture: true }));
        return () => { clearTimeout(t); EVENTS.forEach((e) => window.removeEventListener(e, arm, { capture: true })); };
    }, [active]);

    useEffect(() => {
        if (left === null) return;
        if (left <= 0) { setLeft(null); onTimeout(); return; }
        const t = setTimeout(() => setLeft(left - 1), 1000);
        return () => clearTimeout(t);
    }, [left, onTimeout]);

    if (left === null) return null;
    return (
        <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-md grid place-items-center p-6 blur-in" data-testid="kiosk-idle-modal">
            <div className="border border-[var(--border)] bg-[var(--surface)] p-10 text-center max-w-md w-full">
                <p className="eyebrow">// Still there?</p>
                <div className="font-display text-[96px] leading-none text-gold my-4" data-testid="kiosk-idle-countdown">{left}</div>
                <p className="text-muted text-sm mb-6">Your basket will be cleared when the timer runs out.</p>
                <button className="btn-primary w-full justify-center" data-testid="kiosk-idle-continue">I'm still here</button>
            </div>
        </div>
    );
};
